export default __webpack_public_path__ + "922bb27bfa741f7f4c823ef2e2a5226e.png";